import { X } from "ui/src/components/icons/X";
import { TouchableArea } from "ui/src/components/touchable";
export function CloseIconWithHover({ onClose, size = "$icon.24", testId }) {
  return <TouchableArea data-testid={testId} onPress={onClose}><X size={size} color="$neutral2" hoverColor="$neutral2Hovered" /></TouchableArea>;
}
